import { createContext } from "react";

export const CustomerContext = createContext({});